<template>
  <div class="container resume page">
    <div class="row">
      <div class="body-pane col-lg-8">
        <div class="content">
          <hgroup>
            <h2>RÉSUMÉ</h2>
            <p>There is also a downloadable version on the right section.</p>
          </hgroup>
          <div class="container">
            <h3 class="h4">Technical Skills</h3>
            <div class="row">
              <div class="col-lg-4">
                <ul>
                  <li>HTML</li>
                  <li>CSS/SCSS/SASS/LESS</li>
                  <li>JavaScript</li>
                  <li>Typescript</li>
                  <li>jQuery</li>
                  <li>Vue</li>
                  <li>React</li>
                  <li>Angular</li>
                  <li>Bootstrap</li>
                  <li>Material UI</li>
                  <li>Tailwind CSS</li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul>
                  <li>Foundation</li>
                  <li>PHP</li>
                  <li>WordPress</li>
                  <li>Drupal</li>
                  <li>Joomla!</li>
                  <li>Magento</li>
                  <li>NodeJS</li>
                  <li>NPM</li>
                  <li>Git</li>
                  <li>Jira</li>
                  <li>Tortoise SVN</li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul>
                  <li>MS Source Safe</li>
                  <li>Adobe Creative Suite</li>
                  <li>Adobe PhotoShop</li>
                  <li>Adobe Illustrator</li>
                  <li>Adobe After Effects</li>
                  <li>Adobe Experience Manager (AEM)</li>
                  <li>ServiceNow</li>
                  <li>Sketch</li>
                  <li>GIMP</li>
                  <li>...and many other things</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="container mt-3">
            <h3 class="h4">Relevant Experience</h3>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Software Engineer</strong></li>
                    <li><em>Insight Global</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Jun. 2026 - Aug. 2026</li>
                    <li>Atlanta, GA (Remote)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Debugged, repaired, enhanced a proprietary <strong>React</strong> application, focusing on acccessibiltiy concessions as outlined by WCAG</li>
                    <li>Visually testing updates, testing using NVDA and updading unit tests</li>
                    <li>Reviewing peer pull requests.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Senior Front End UI Engineer</strong></li>
                    <li><em>USA Small Business Administration</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Feb. 2022 - Apr. 2025</li>
                    <li>Washington, DC (Remote)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Built the mobile-first front end UI, using <strong>Vue</strong> for a lending app which now processes over $9M/mo.</li>
                    <li>Worked with UX Designers to ensure the app is scalable, extendable and downgrades gracefully.</li>
                    <li>Implemented usability and accessibility standards: <strong>Section 508</strong>, <strong>ADA</strong>, <strong>WCAG compliance</strong>.</li>
                    <li>Participated regularly in sprint planning, retrospectives and peer code reviews.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Senior Front End UI Engineer</strong></li>
                    <li><em>County of San Bernardino - Information Technology Department</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Feb. 2020 - Feb. 2022</li>
                    <li>San Bernardino, CA (Hybrid)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Built and maintained several county department sites using <strong>WordPress</strong> and <strong>React</strong>.</li>
                    <li>Regularly conducted training for county departments on how to maintain the <strong>WordPress</strong> content.</li>
                    <li>Wrote and maintained documentation on site design and development structure in <strong>Confluence</strong>.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>JavaScript Engineer</strong></li>
                    <li><em>SitusAMC</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Oct. 2018 - Nov. 2019</li>
                    <li>Denver, CO (Hybrid)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Maintained an internally-facing app called Clarity, used to manage commercial real estate loans.</li>
                    <li>Wrote and maintained documentation on changes and upgrades in <strong>JIRA</strong>.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Front End Web Developer</strong></li>
                    <li><em>PlaceWise Digital</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Apr. 2018 - Oct. 2018</li>
                    <li>Denver, CO (Hybrid)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Maintained several websites for brick-and-mortar malls across USA using <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Wrote and maintained documentation on changes and upgrades in <strong>JIRA</strong> and <strong>Confluence</strong>.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Application Development Specialist</strong></li>
                    <li><em>Accenture</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Mar. 2015 - Mar. 2018</li>
                    <li>El Segundo, CA (Hybrid)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Worked for client, Charter/Spectrum to update marketing sites in <strong>AEM</strong>, <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Worked for client, State of CA to debug a <strong>React</strong> app, primarily faulty <strong>JavaScript</strong>.</li>
                    <li>Worked for client, Dell Computers to develop an <strong>Angular</strong> app for internal inventory control.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Front End Web Developer</strong></li>
                    <li><em>Riot Games, Inc.</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Nov. 2013 - Feb. 2015</li>
                    <li>Santa Monica, CA (On-site)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Maintained internally-facing <strong>WordPress</strong>, <strong>ServiceNow</strong> app aesthetics: <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Developed an maintained front end of an employee directory app using <strong>Angular</strong>.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>E-Commerce Developer</strong></li>
                    <li><em>TOMS Shoes, Inc.</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Oct. 2012 - Nov. 2013</li>
                    <li>Los Angeles, CA (On-site)</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Maintained stores apps in <strong>Magento</strong>, <strong>WordPress</strong> and added features in <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Developed the front end of the ATG site expanding to Eastern Europe.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Front End Application Support</strong></li>
                    <li><em>The National Football League (NFL)</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>Jun. 2012 - Sep. 2012</li>
                    <li>Culver City, CA</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Seasonal position maintaining team sites in <strong>Interwoven CMS</strong>, <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Documentation on updates and added features in <strong>JIRA</strong>.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="job">
              <div class="row experience">
                <div class="col-lg-8">
                  <ul class="none">
                    <li><strong>Front End Web Developer</strong></li>
                    <li><em>Esri, Inc.</em></li>
                  </ul>
                </div>
                <div class="col-lg-4 text-lg-end">
                  <ul class="none">
                    <li>May 2010 - May 2012</li>
                    <li>Redlands, CA</li>
                  </ul>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <ul class="mt-2 ms-3">
                    <li>Maintained the Training and Event micro-sites in <strong>HTML</strong>, <strong>CSS</strong>, <strong>JavaScript</strong>.</li>
                    <li>Documentation on updates and added features in <strong>Confluence</strong>, <strong>JIRA</strong>. Version control in <strong>MVSS</strong>.</li>
                  </ul>
                  <p class="text-center">Futher experience extending to 2008 and professional references provided upon request.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="container mt-3">
            <h3 class="h4">Education</h3>
            <div class="row education">
              <div class="col-lg-6">
                  <ul class="none">
                    <li><strong>Bachelor of Science Degree</strong></li>
                    <li><em>Art Institute of California, Inland Empire</em></li>
                  </ul>
                </div>
                <div class="col-lg-6 text-lg-end">
                  <ul class="none">
                    <li>Graduated with Honors: March 2009</li>
                    <li>San Bernardino, CA</li>
                  </ul>
                </div>
            </div>
            <div class="row education mt-3">
              <div class="col-lg-6">
                  <ul class="none">
                    <li><strong>Associate of Science Degree</strong></li>
                    <li><em>Art Institute of Phoenix</em></li>
                  </ul>
                </div>
                <div class="col-lg-6 text-lg-end">
                  <ul class="none">
                    <li>Graduated with Honors: June 1997</li>
                    <li>Phoenix, AZ</li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="aux col-lg-4">
        <div class="docs">
          <h3>DOWNLOADABLE DOCS</h3>
          <a href="Resume_2026_2.pdf" download>Resume in PDF format (10kb)</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeView',
}
</script>
